import { useMutation } from '@tanstack/react-query';
import { useInvalidateCurrentUser } from './user-info';
import {
  getTwitchRemove,
  validateTwitchCode,
} from '../../services/client/twitch';
import { useToast } from '@wwe-portal/ui/components/toast';
import { useRouter } from 'next/navigation';
import { getStorageItem } from '../../libs/bridge/local-storage';
import { STORAGE_ITEM_TWITCH_CONNECT_PREVIOUS_PATH } from '../../utils/constants/keys';

export const useTwitchRemove = () => {
  const invalidateUser = useInvalidateCurrentUser();
  return useMutation({
    mutationFn: () => getTwitchRemove(),
    onSettled: invalidateUser,
  });
};

export const useTwitchValidate = () => {
  const invalidateUser = useInvalidateCurrentUser();
  const { toast } = useToast();
  const router = useRouter();

  return useMutation({
    mutationFn: validateTwitchCode,
    onError: () => {
      toast({
        variant: 'error',
        content: 'Failed to connect to Twitch. Please try again.',
      });
    },
    onSettled: () => {
      invalidateUser();
      const path =
        getStorageItem(STORAGE_ITEM_TWITCH_CONNECT_PREVIOUS_PATH) ?? '/';
      router.push(path);
    },
  });
};
